import { toPaginate } from '@/utils/infrastructure';
import _ from 'lodash';
import { bindServices } from '@/services/api';

const api = bindServices('userGroupArea');

import { queryEditActive } from './service';

const pagination = {
  page: 1,
  limit: 5,
  count: 0,
  totalPages: 0,
};

const initialState = {
  newUserGroupArea: false,
  selectedItem: null,
  formConfig: null,
  list: [],
  pagination,
  select: 'id,approvalLevel',
  notSelectSearch: 'approvalLevel',
  expand: {
    area: { select: 'name' },
    userGroup: { select: 'name' },
  },
  paramsView: {
    select: 'id,approvalLevel,created',
    expand: {
      userGroup: { select: 'name' },
      area: { select: 'name' },
      userCreator: { select: 'fullName' },
    },
  },
  paramsEdit: {
    select: 'id,approvalLevel,userGroupId,areaId ',
  },
  view: false,
  orderBy: '',
  id: null,
};

const Model = {
  namespace: 'userGroupArea',

  state: initialState,

  effects: {
    *fetchList({ payload }, { call, put }) {
      try {
        const response = yield call(api.getAll, {
          route: 'globalUserGroupApproverByArea/paged',
          params: payload,
        });

        yield put({
          type: 'setListUserGroupArea',
          payload: {
            ...response,
            page: payload.page,
            limit: payload.limit,
          },
        });
      } catch (error) {
        /*  */
      }
    },
    *openModalUserGroupArea({ payload }, { put }) {
      yield put({
        type: 'addUserGroupArea',
        payload,
      });

      if (!_.isNil(payload.id)) {
        yield put({
          type: 'editOrViewUserGroupArea',
          payload,
        });
      }
    },
    *saveNewUserGroupArea({ payload, params }, { call, put }) {
      try {
        const response = yield call(api.create, {
          route: 'globalUserGroupApproverByArea',
          data: payload,
        });
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });

        yield put({
          type: 'saveUserGroupArea',
          payload: response,
        });

        yield put({
          type: 'fetchList',
          payload: params,
        });
      } catch (error) {
        if (error.message) {
          if (_.isEmpty(error.validationErrors[0].field)) {
            _.set(error, 'message', error.validationErrors[0].errorMessages[0]);
          }

          yield put({
            type: 'global/showNotificationsForm',
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
            },
            validationErrors: error.validationErrors,
          });
        }
      }
    },
    *editItemUserGroupArea({ payload }, { call, put }) {
      try {
        const table = yield call(api.getById, {
          route: 'globalUserGroupApproverByArea',
          id: payload.id,
          params: payload.params,
        });
        yield put({
          type: 'editUserGroupArea',
          payload: {
            ...payload,
            state: true,
            item: table,
          },
        });
      } catch (error) {
        /*  */
      }
    },
    *saveEditUserGroupArea({ payload, params }, { call, put }) {
      try {
        const response = yield call(api.update, {
          route: 'globalUserGroupApproverByArea',
          data: payload,
        });
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });

        yield put({
          type: 'saveUserGroupArea',
          payload: response,
        });

        yield put({
          type: 'fetchList',
          payload: params,
        });
      } catch (error) {
        if (error.message) {
          if (_.isEmpty(error.validationErrors[0].field)) {
            _.set(error, 'message', error.validationErrors[0].errorMessages[0]);
          }

          yield put({
            type: 'global/showNotificationsForm',
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
            },
            validationErrors: error.validationErrors,
          });
        }
      }
    },
    *deleteItem({ id, params, view }, { call, put }) {
      try {
        yield put({
          type: `global/modalConfirm`,
          state: false,
          id: null,
        });

        const response = yield call(api.apiRoute, {
          route: `globalUserGroupApproverByArea/${id}`,
          method: 'delete',
        });

        yield put({
          type: 'saveUserGroupArea',
          payload: response,
        });

        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });

        yield put({
          type: 'fetchList',
          payload: params,
        });
      } catch (error) {
        yield put({
          type: `global/modalConfirm`,
          state: false,
          id: null,
        });

        if (error && error.message) {
          yield put({
            type: `global/showNotifications${view ? 'Form' : 'Global'}`,
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
              autoHide: view,
            },
          });
        }
      }
    },
    *editActive({ payload, params }, { call, put }) {
      try {
        yield call(queryEditActive, params);
        yield put({
          type: 'editActives',
          payload,
        });
      } catch (error) {
        /*  */
      }
    },
    *showItemUser({ view }, { put }) {
      yield put({
        type: 'showEditItemUser',
        view,
      });
    },
    *hideAllForms({ payload = 'hideForms' }, { put }) {
      yield put({ type: payload });
    },
    *setOrderBy({ payload }, { put }) {
      yield put({
        type: 'orderBy',
        payload,
      });
    },
  },

  reducers: {
    setListUserGroupArea(state, { payload }) {
      return {
        ...state,
        list: payload.items,
        pagination: _.merge(state.pagination, toPaginate(payload)),
      };
    },
    addUserGroupArea(state, { payload }) {
      return {
        ...state,
        newUserGroupArea: payload.state,
        selectedItem: payload.item,
        view: payload.view,
        id: payload.id,
      };
    },
    editOrViewUserGroupArea(state) {
      return {
        ...state,
        selectedItem: {},
      };
    },
    saveUserGroupArea(state, { payload }) {
      return {
        ...state,
        saveUserGroupArea: payload,
        newUserGroupArea: false,
        selectedItem: null,
        view: false,
      };
    },
    editUserGroupArea(state, { payload }) {
      return {
        ...state,
        selectedItem: payload.item,
        view: payload.view,
        id: payload.id,
      };
    },
    editActives(state, { payload }) {
      const list = state.list.map((item) => (item.id === payload.id ? payload : item));

      return {
        ...state,
        list,
      };
    },
    showEditItemUserGroupArea(state, { view }) {
      return {
        ...state,
        view,
      };
    },
    orderBy(state, { payload }) {
      return {
        ...state,
        orderBy: payload,
      };
    },
    hideForms(state) {
      return {
        ...state,
        newUserGroupArea: false,
        selectedItem: null,
        formConfig: null,
        list: [],
        view: false,
        orderBy: '',
      };
    },
  },
};

export default Model;
